class Faq {

  constructor(element) {
    this.element = element;
    this.items = element.querySelectorAll('[js-accordion]')
    this.entities = []
    this.init();
  }

  init() {
    this.items.forEach(item => {
      const title = item.querySelector('[js-accordion-button]').innerText;
      const answer = item.querySelector('[js-accordion-text]').innerText;
      this.entities.push({
        '@type': 'Question',
        'name': title,
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': answer
        }
      })
    })
    this.addToHead()
  }

  addToHead() {
    const structuredDataText = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": this.entities
    }
    const script = document.createElement('script');
    script.setAttribute('type', 'application/ld+json');
    script.textContent = JSON.stringify(structuredDataText);
    document.head.appendChild(script);
  }

}

export default Faq;